var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmoticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9908 0C5.7635 0 0.720703 5.04 0.720703 11.25C0.720703 17.46 5.7635 22.5 11.9908 22.5C18.2295 22.5 23.2836 17.46 23.2836 11.25C23.2836 5.04 18.2295 0 11.9908 0ZM8.05363 6.75C8.98999 6.75 9.74584 7.50375 9.74584 8.4375C9.74584 9.37125 8.98999 10.125 8.05363 10.125C7.11727 10.125 6.36142 9.37125 6.36142 8.4375C6.36142 7.50375 7.11727 6.75 8.05363 6.75ZM12.0021 18C11.2945 18 10.616 17.8587 9.9857 17.599C7.42091 16.5422 9.22814 13.5 12.0021 13.5C14.7761 13.5 16.5833 16.5422 14.0186 17.599C13.3883 17.8587 12.7097 18 12.0021 18ZM15.9506 10.125C15.0143 10.125 14.2584 9.37125 14.2584 8.4375C14.2584 7.50375 15.0143 6.75 15.9506 6.75C16.887 6.75 17.6428 7.50375 17.6428 8.4375C17.6428 9.37125 16.887 10.125 15.9506 10.125Z",
    fill: "#7E98DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmoticon);
export default __webpack_public_path__ + "static/media/icon-emoticon.8bd01de7bd514ed8add9c84ece7f36f9.svg";
export { ForwardRef as ReactComponent };